var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5289 10.4688C11.7893 10.7291 12.2114 10.7291 12.4717 10.4688C12.7321 10.2085 12.7321 9.78634 12.4717 9.52599L8.47173 5.52599C8.21138 5.26564 7.78927 5.26564 7.52892 5.52599L3.52892 9.52599C3.26857 9.78634 3.26857 10.2085 3.52892 10.4688C3.78927 10.7291 4.21138 10.7291 4.47173 10.4688L8.00033 6.9402L11.5289 10.4688Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.2a4d3eb9d13dda68ab194c377033b5a4.svg";
export { ForwardRef as ReactComponent };